import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMessageSquare, FiClock, FiArrowRight, FiHeart } = FiIcons;

const RecentTributesHistory = () => {
  const contributions = [
    { id: 1, target: "Eleanor Thompson", message: "Thinking of you today, Eleanor. Your garden is in full bloom.", date: "2 hours ago", type: "Candle Lit" },
    { id: 2, target: "Captain Marcus Chen", message: "Fair winds, Captain. Thank you for your service.", date: "Yesterday", type: "Message" },
  ];

  return (
    <div className="bg-white rounded-[40px] border border-brand-dark p-8 shadow-sm">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent-gold/10 rounded-xl flex items-center justify-center text-accent-gold">
            <SafeIcon icon={FiMessageSquare} />
          </div>
          <h3 className="font-serif text-xl text-accent-navy">Your Tributes</h3>
        </div>
        <button className="text-[10px] font-black uppercase tracking-widest text-text-muted hover:text-accent-gold transition-colors">View All</button>
      </div>

      {contributions.length === 0 ? (
        <div className="py-12 text-center">
          <div className="w-14 h-14 bg-brand-light rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-dark">
            <SafeIcon icon={FiHeart} className="w-7 h-7 text-accent-gold/40" />
          </div>
          <p className="text-sm font-serif text-accent-navy mb-1">No Tributes Yet</p>
          <p className="text-xs text-text-muted font-light italic">
            Tributes you leave on memorial pages will appear here.
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {contributions.map((item, idx) => (
            <div key={item.id} className="relative pl-6 border-l-2 border-brand-dark group">
              <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-white border-4 border-accent-gold" />
              <div className="mb-1 flex items-center justify-between">
                <span className="text-[10px] font-black uppercase tracking-widest text-accent-navy">For {item.target}</span>
                <span className="text-[9px] font-bold text-text-muted flex items-center gap-1">
                  <SafeIcon icon={FiClock} className="w-3 h-3" /> {item.date}
                </span>
              </div>
              <p className="text-sm text-text-muted font-light italic line-clamp-2 mb-2">"{item.message}"</p>
              <div className="flex items-center gap-2 text-[9px] font-black uppercase tracking-tighter text-accent-gold">
                {item.type}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentTributesHistory;